module.exports = __webpack_public_path__ + "img/VicePresidente.99416359.png";